<template>
   <span  @click="scrollToTop" data-target="html" class="scroll-to-target scroll-to-top">
    <span class="bar-inner"></span><!-- /.bar-inner --><i class="fa fa-angle-up"></i>
  </span>
</template>

<script>
export default {
  data() {
    return {};
  },methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>
<style>

</style>
